module.exports = __webpack_public_path__ + "static/media/Celeb6.feaec1f6.jpg";